import * as React from "react"
import { router } from "@inertiajs/react"
import { useIntl } from "react-intl"
import { MessageCircle } from "lucide-react"
import { Button } from "@/components/ui/button"

/** Opens a new assistant chat about an answered quiz or exam question. */
export function AskAssistantButton({ attemptId, questionId }: { attemptId: number; questionId: number }) {
  const intl = useIntl()
  const [processing, setProcessing] = React.useState(false)
  return (
    <Button
      type="button"
      variant="secondary"
      size="sm"
      disabled={processing}
      onClick={() =>
        router.post(
          "/conversations/from_question",
          { attempt_id: attemptId, question_id: questionId },
          { onStart: () => setProcessing(true), onFinish: () => setProcessing(false) },
        )
      }
    >
      <MessageCircle className="h-4 w-4" /> {intl.formatMessage({ id: "assistant.ask" })}
    </Button>
  )
}
